import Cookies from "universal-cookie";
const cookies = new Cookies();

////////////////////////////////////////////////////////////

let _Idioma = "Español";

export function setIdioma(value) {
  _Idioma = value;
  localStorage.setItem("Idioma", _Idioma);
  cookies.set("Idioma", _Idioma, { path: "/" });
}

export function getIdioma() {
  if (
    localStorage.getItem("Idioma") === null ||
    localStorage.getItem("Idioma") === undefined
  ) {
    if (cookies.get("Idioma") === null || cookies.get("Idioma") === undefined) {
    } else {
      _Idioma = cookies.get("Idioma");
    }
  } else {
    _Idioma = localStorage.getItem("Idioma");
  }

  return _Idioma;
}

////////////////////////////////////////////////////////////

let _Token = "";

export function setToken(value) {
  _Token = value;
  localStorage.setItem("Token", _Token);
  cookies.set("Token", _Token, { path: "/" });
}

export function getToken() {
  if (
    localStorage.getItem("Token") === null ||
    localStorage.getItem("Token") === undefined
  ) {
    if (cookies.get("Token") === null || cookies.get("Token") === undefined) {
    } else {
      _Token = cookies.get("Token");
    }
  } else {
    _Token = localStorage.getItem("Token");
  }

  return _Token;
}

////////////////////////////////////////////////////////////

let _Localidad = "";

export function setLocalidad(value) {
  _Localidad = value;
  localStorage.setItem("Localidad", _Localidad);
  cookies.set("Localidad", _Localidad, { path: "/" });
}

export function getLocalidad() {
  if (
    localStorage.getItem("Localidad") === null ||
    localStorage.getItem("Localidad") === undefined
  ) {
    if (
      cookies.get("Localidad") === null ||
      cookies.get("Localidad") === undefined
    ) {
    } else {
      _Localidad = cookies.get("Localidad");
    }
  } else {
    _Localidad = localStorage.getItem("Localidad");
  }

  return _Localidad;
}

////////////////////////////////////////////////////////////

let _email = "";

export function setemail(value) {
  _email = value;
  localStorage.setItem("email", _email);
  cookies.set("email", _email, { path: "/" });
}

export function getemail() {
  if (
    localStorage.getItem("email") === null ||
    localStorage.getItem("email") === undefined
  ) {
    if (cookies.get("email") === null || cookies.get("email") === undefined) {
    } else {
      _email = cookies.get("email");
    }
  } else {
    _email = localStorage.getItem("email");
  }

  return _email;
}

////////////////////////////////////////////////////////////

let _nombreBanco = "";

export function setNombrebanco(value) {
  _nombreBanco = value;
  localStorage.setItem("nombreBanco", _nombreBanco);
  cookies.set("nombreBanco", _nombreBanco, { path: "/" });
}

export function getNombreBanco() {
  if (
    localStorage.getItem("nombreBanco") === null ||
    localStorage.getItem("nombreBanco") === undefined
  ) {
    if (
      cookies.get("email") === null ||
      cookies.get("nombreBanco") === undefined
    ) {
    } else {
      _nombreBanco = cookies.get("nombreBanco");
    }
  } else {
    _nombreBanco = localStorage.getItem("nombreBanco");
  }

  return _nombreBanco;
}

////////////////////////////////////////////////////////////

let _titular = "";

export function setTitular(value) {
  _titular = value;
  localStorage.setItem("titular", _titular);
  cookies.set("titular", _titular, { path: "/" });
}

export function getTitular() {
  if (
    localStorage.getItem("titular") === null ||
    localStorage.getItem("titular") === undefined
  ) {
    if (
      cookies.get("titular") === null ||
      cookies.get("titular") === undefined
    ) {
    } else {
      _titular = cookies.get("titular");
    }
  } else {
    _titular = localStorage.getItem("titular");
  }

  return _titular;
}

////////////////////////////////////////////////////////////

let _CBU = "";

export function setCBU(value) {
  _CBU = value;
  localStorage.setItem("CBU", _CBU);
  cookies.set("CBU", _CBU, { path: "/" });
}

export function getCBU() {
  if (
    localStorage.getItem("CBU") === null ||
    localStorage.getItem("CBU") === undefined
  ) {
    if (cookies.get("CBU") === null || cookies.get("CBU") === undefined) {
    } else {
      _CBU = cookies.get("CBU");
    }
  } else {
    _CBU = localStorage.getItem("CBU");
  }

  return _CBU;
}
////////////////////////////////////////////////////////////

let _CodigoRecuperacion = "";

export function setCodigoRecuperacion(value) {
  _CodigoRecuperacion = value;
  localStorage.setItem("CodigoRecuperacion", _CodigoRecuperacion);
  cookies.set("CodigoRecuperacion", _CodigoRecuperacion, { path: "/" });
}

export function getCodigoRecuperacion() {
  if (
    localStorage.getItem("CodigoRecuperacion") === null ||
    localStorage.getItem("CodigoRecuperacion") === undefined
  ) {
    if (
      cookies.get("CodigoRecuperacion") === null ||
      cookies.get("CodigoRecuperacion") === undefined
    ) {
    } else {
      _CodigoRecuperacion = cookies.get("CodigoRecuperacion");
    }
  } else {
    _CodigoRecuperacion = localStorage.getItem("CodigoRecuperacion");
  }

  return _CodigoRecuperacion;
}

////////////////////////////////////////////////////////////

let _role = "";

export function setrole(value) {
  _role = value;
  localStorage.setItem("role", _role);
  cookies.set("role", _role, { path: "/" });
}

export function getrole() {
  if (
    localStorage.getItem("role") === null ||
    localStorage.getItem("role") === undefined
  ) {
    if (cookies.get("role") === null || cookies.get("role") === undefined) {
    } else {
      _role = cookies.get("role");
    }
  } else {
    _role = localStorage.getItem("role");
  }

  return _role;
}

////////////////////////////////////////////////////////////

let _password = "";

export function setpassword(value) {
  _password = value;
  localStorage.setItem("password", _password);
  cookies.set("password", _password, { path: "/" });
}

export function getpassword() {
  if (
    localStorage.getItem("password") === null ||
    localStorage.getItem("password") === undefined
  ) {
    if (
      cookies.get("password") === null ||
      cookies.get("password") === undefined
    ) {
    } else {
      _password = cookies.get("password");
    }
  } else {
    _password = localStorage.getItem("password");
  }

  return _password;
}

////////////////////////////////////////////////////////////

let _Nombre = "";

export function setNombre(value) {
  _Nombre = value;
  localStorage.setItem("Nombre", _Nombre);
  cookies.set("Nombre", _Nombre, { path: "/" });
}

export function getNombre() {
  if (
    localStorage.getItem("Nombre") === null ||
    localStorage.getItem("Nombre") === undefined
  ) {
    if (cookies.get("Nombre") === null || cookies.get("Nombre") === undefined) {
    } else {
      _Nombre = cookies.get("Nombre");
    }
  } else {
    _Nombre = localStorage.getItem("Nombre");
  }

  return _Nombre;
}

////////////////////////////////////////////////////////////

let _Apellido = "";

export function setApellido(value) {
  _Apellido = value;
  localStorage.setItem("Apellido", _Apellido);
  cookies.set("Apellido", _Apellido, { path: "/" });
}

export function getApellido() {
  if (
    localStorage.getItem("Apellido") === null ||
    localStorage.getItem("Apellido") === undefined
  ) {
    if (
      cookies.get("Apellido") === null ||
      cookies.get("Apellido") === undefined
    ) {
    } else {
      _Apellido = cookies.get("Apellido");
    }
  } else {
    _Apellido = localStorage.getItem("Apellido");
  }

  return _Apellido;
}

////////////////////////////////////////////////////////////

let _Telefono = "";

export function setTelefono(value) {
  _Telefono = value;
  localStorage.setItem("Telefono", _Telefono);
  cookies.set("Telefono", _Telefono, { path: "/" });
}

export function getTelefono() {
  if (
    localStorage.getItem("Telefono") === null ||
    localStorage.getItem("Telefono") === undefined
  ) {
    if (
      cookies.get("Telefono") === null ||
      cookies.get("Telefono") === undefined
    ) {
    } else {
      _Telefono = cookies.get("Telefono");
    }
  } else {
    _Telefono = localStorage.getItem("Telefono");
  }

  return _Telefono;
}

////////////////////////////////////////////////////////////

let _avatar = "";

export function setavatar(value) {
  _avatar = value;
  localStorage.setItem("avatar", _avatar);
  cookies.set("avatar", _avatar, { path: "/" });
}

export function getavatar() {
  if (
    localStorage.getItem("avatar") === null ||
    localStorage.getItem("avatar") === undefined
  ) {
    if (cookies.get("avatar") === null || cookies.get("avatar") === undefined) {
    } else {
      _avatar = cookies.get("avatar");
    }
  } else {
    _avatar = localStorage.getItem("avatar");
  }

  return _avatar;
}

////////////////////////////////////////////////////////////

let _id = "";

export function setid(value) {
  _id = value;
  localStorage.setItem("id", _id);
  cookies.set("id", _id, { path: "/" });
}

export function getid() {
  if (
    localStorage.getItem("id") === null ||
    localStorage.getItem("id") === undefined
  ) {
    if (cookies.get("id") === null || cookies.get("id") === undefined) {
    } else {
      _id = cookies.get("id");
    }
  } else {
    _id = localStorage.getItem("id");
  }

  return _id;
}

////////////////////////////////////////////////////////////

let _menuAbajoSeleccionado = "";

export function setmenuAbajoSeleccionado(value) {
  _menuAbajoSeleccionado = value;
  localStorage.setItem("menuAbajoSeleccionado", _menuAbajoSeleccionado);
  cookies.set("menuAbajoSeleccionado", _menuAbajoSeleccionado, { path: "/" });
}

export function getmenuAbajoSeleccionado() {
  if (
    localStorage.getItem("menuAbajoSeleccionado") === null ||
    localStorage.getItem("menuAbajoSeleccionado") === undefined
  ) {
    if (
      cookies.get("menuAbajoSeleccionado") === null ||
      cookies.get("menuAbajoSeleccionado") === undefined
    ) {
    } else {
      _menuAbajoSeleccionado = cookies.get("menuAbajoSeleccionado");
    }
  } else {
    _menuAbajoSeleccionado = localStorage.getItem("menuAbajoSeleccionado");
  }

  return _menuAbajoSeleccionado;
}

////////////////////////////////////////////////////////////

let _menuLateralSeleccionado = "";

export function setmenuLateralSeleccionado(value) {
  _menuLateralSeleccionado = value;
  localStorage.setItem("menuLateralSeleccionado", _menuLateralSeleccionado);
  cookies.set("menuLateralSeleccionado", _menuLateralSeleccionado, {
    path: "/",
  });
}

export function getmenuLateralSeleccionado() {
  if (
    localStorage.getItem("menuLateralSeleccionado") === null ||
    localStorage.getItem("menuLateralSeleccionado") === undefined
  ) {
    if (
      cookies.get("menuLateralSeleccionado") === null ||
      cookies.get("menuLateralSeleccionado") === undefined
    ) {
    } else {
      _menuLateralSeleccionado = cookies.get("menuLateralSeleccionado");
    }
  } else {
    _menuLateralSeleccionado = localStorage.getItem("menuLateralSeleccionado");
  }

  return _menuLateralSeleccionado;
}

////////////////////////////////////////////////////////////

let _menuLateralDerechoSeleccionado = "";

export function setmenuLateralDerechoSeleccionado(value) {
  _menuLateralDerechoSeleccionado = value;
  localStorage.setItem(
    "menuLateralDerechoSeleccionado",
    _menuLateralDerechoSeleccionado
  );
  cookies.set(
    "menuLateralDerechoSeleccionado",
    _menuLateralDerechoSeleccionado,
    { path: "/" }
  );
}

export function getmenuLateralDerechoSeleccionado() {
  if (
    localStorage.getItem("menuLateralDerechoSeleccionado") === null ||
    localStorage.getItem("menuLateralDerechoSeleccionado") === undefined
  ) {
    if (
      cookies.get("menuLateralDerechoSeleccionado") === null ||
      cookies.get("menuLateralDerechoSeleccionado") === undefined
    ) {
    } else {
      _menuLateralDerechoSeleccionado = cookies.get(
        "menuLateralDerechoSeleccionado"
      );
    }
  } else {
    _menuLateralDerechoSeleccionado = localStorage.getItem(
      "menuLateralDerechoSeleccionado"
    );
  }

  return _menuLateralDerechoSeleccionado;
}

////////////////////////////////////////////////////////////

let _Titulo = "";

export function setTitulo(value) {
  _Titulo = value;
  localStorage.setItem("Titulo", _Titulo);
  cookies.set("Titulo", _Titulo, { path: "/" });
}

export function getTitulo() {
  if (
    localStorage.getItem("Titulo") === null ||
    localStorage.getItem("Titulo") === undefined
  ) {
    if (cookies.get("Titulo") === null || cookies.get("Titulo") === undefined) {
    } else {
      _Titulo = cookies.get("Titulo");
    }
  } else {
    _Titulo = localStorage.getItem("Titulo");
  }

  return _Titulo;
}

////////////////////////////////////////////////////////////

let _PermiteCambiarEmail = "";

export function setPermiteCambiarEmail(value) {
  _PermiteCambiarEmail = value;
  localStorage.setItem("PermiteCambiarEmail", _PermiteCambiarEmail);
  cookies.set("PermiteCambiarEmail", _PermiteCambiarEmail, { path: "/" });
}

export function getPermiteCambiarEmail() {
  if (
    localStorage.getItem("PermiteCambiarEmail") === null ||
    localStorage.getItem("PermiteCambiarEmail") === undefined
  ) {
    if (
      cookies.get("PermiteCambiarEmail") === null ||
      cookies.get("PermiteCambiarEmail") === undefined
    ) {
    } else {
      _PermiteCambiarEmail = cookies.get("PermiteCambiarEmail");
    }
  } else {
    _PermiteCambiarEmail = localStorage.getItem("PermiteCambiarEmail");
  }

  return _PermiteCambiarEmail;
}

////////////////////////////////////////////////////////////

let _ActivarCuenta_PrimeraVezQueIngresa = "";

export function setActivarCuenta_PrimeraVezQueIngresa(value) {
  _ActivarCuenta_PrimeraVezQueIngresa = value;
  localStorage.setItem(
    "ActivarCuenta_PrimeraVezQueIngresa",
    _ActivarCuenta_PrimeraVezQueIngresa
  );
  cookies.set(
    "ActivarCuenta_PrimeraVezQueIngresa",
    _ActivarCuenta_PrimeraVezQueIngresa,
    { path: "/" }
  );
}

export function getActivarCuenta_PrimeraVezQueIngresa() {
  if (
    localStorage.getItem("ActivarCuenta_PrimeraVezQueIngresa") === null ||
    localStorage.getItem("ActivarCuenta_PrimeraVezQueIngresa") === undefined
  ) {
    if (
      cookies.get("ActivarCuenta_PrimeraVezQueIngresa") === null ||
      cookies.get("ActivarCuenta_PrimeraVezQueIngresa") === undefined
    ) {
    } else {
      _ActivarCuenta_PrimeraVezQueIngresa = cookies.get(
        "ActivarCuenta_PrimeraVezQueIngresa"
      );
    }
  } else {
    _ActivarCuenta_PrimeraVezQueIngresa = localStorage.getItem(
      "ActivarCuenta_PrimeraVezQueIngresa"
    );
  }

  return _ActivarCuenta_PrimeraVezQueIngresa;
}

////////////////////////////////////////////////////////////

let _LatitudGPS = "";

export function setLatitudGPS(value) {
  _LatitudGPS = value;
  localStorage.setItem("LatitudGPS", _LatitudGPS);
  cookies.set("LatitudGPS", _LatitudGPS, { path: "/" });
}

export function getLatitudGPS() {
  if (
    localStorage.getItem("LatitudGPS") === null ||
    localStorage.getItem("LatitudGPS") === undefined
  ) {
    if (
      cookies.get("LatitudGPS") === null ||
      cookies.get("LatitudGPS") === undefined
    ) {
    } else {
      _LatitudGPS = cookies.get("LatitudGPS");
    }
  } else {
    _LatitudGPS = localStorage.getItem("LatitudGPS");
  }

  return _LatitudGPS;
}

////////////////////////////////////////////////////////////

let _LongitudGPS = "";

export function setLongitudGPS(value) {
  _LongitudGPS = value;
  localStorage.setItem("LongitudGPS", _LongitudGPS);
  cookies.set("LongitudGPS", _LongitudGPS, { path: "/" });
}

export function getLongitudGPS() {
  if (
    localStorage.getItem("LongitudGPS") === null ||
    localStorage.getItem("LongitudGPS") === undefined
  ) {
    if (
      cookies.get("LongitudGPS") === null ||
      cookies.get("LongitudGPS") === undefined
    ) {
    } else {
      _LongitudGPS = cookies.get("LongitudGPS");
    }
  } else {
    _LongitudGPS = localStorage.getItem("LongitudGPS");
  }

  return _LongitudGPS;
}

////////////////////////////////////////////////////////////

let _LatitudIP = "";

export function setLatitudIP(value) {
  _LatitudIP = value;
  localStorage.setItem("LatitudIP", _LatitudIP);
  cookies.set("LatitudIP", _LatitudIP, { path: "/" });
}

export function getLatitudIP() {
  if (
    localStorage.getItem("LatitudIP") === null ||
    localStorage.getItem("LatitudIP") === undefined
  ) {
    if (
      cookies.get("LatitudIP") === null ||
      cookies.get("LatitudIP") === undefined
    ) {
    } else {
      _LatitudIP = cookies.get("LatitudIP");
    }
  } else {
    _LatitudIP = localStorage.getItem("LatitudIP");
  }

  return _LatitudIP;
}

////////////////////////////////////////////////////////////

let _LongitudIP = "";

export function setLongitudIP(value) {
  _LongitudIP = value;
  localStorage.setItem("LongitudIP", _LongitudIP);
  cookies.set("LongitudIP", _LongitudIP, { path: "/" });
}

export function getLongitudIP() {
  if (
    localStorage.getItem("LongitudIP") === null ||
    localStorage.getItem("LongitudIP") === undefined
  ) {
    if (
      cookies.get("LongitudIP") === null ||
      cookies.get("LongitudIP") === undefined
    ) {
    } else {
      _LongitudIP = cookies.get("LongitudIP");
    }
  } else {
    _LongitudIP = localStorage.getItem("LongitudIP");
  }

  return _LongitudIP;
}

////////////////////////////////////////////////////////////

let _ContactosEmergencia = "";

export function setContactosEmergencia(value) {
  _ContactosEmergencia = value;
  localStorage.setItem("ContactosEmergencia", _ContactosEmergencia);
  cookies.set("ContactosEmergencia", _ContactosEmergencia, { path: "/" });
}

export function getContactosEmergencia() {
  if (
    localStorage.getItem("ContactosEmergencia") === null ||
    localStorage.getItem("ContactosEmergencia") === undefined
  ) {
    if (
      cookies.get("ContactosEmergencia") === null ||
      cookies.get("ContactosEmergencia") === undefined
    ) {
    } else {
      _ContactosEmergencia = cookies.get("ContactosEmergencia");
    }
  } else {
    _ContactosEmergencia = localStorage.getItem("ContactosEmergencia");
  }

  return _ContactosEmergencia;
}

////////////////////////////////////////////////////////////

let _EstadoConexion = "";

export function setEstadoConexion(value) {
  _EstadoConexion = value;
  localStorage.setItem("EstadoConexion", _EstadoConexion);
  cookies.set("EstadoConexion", _EstadoConexion, { path: "/" });
}

export function getEstadoConexion() {
  if (
    localStorage.getItem("EstadoConexion") === null ||
    localStorage.getItem("EstadoConexion") === undefined
  ) {
    if (
      cookies.get("EstadoConexion") === null ||
      cookies.get("EstadoConexion") === undefined
    ) {
    } else {
      _EstadoConexion = cookies.get("EstadoConexion");
    }
  } else {
    _EstadoConexion = localStorage.getItem("EstadoConexion");
  }

  return _EstadoConexion;
}

////////////////////////////////////////////////////////////

let _EstadoConductor = "";

export function setEstadoConductor(value) {
  _EstadoConductor = value;
  localStorage.setItem("EstadoConductor", _EstadoConductor);
  cookies.set("EstadoConductor", _EstadoConductor, { path: "/" });
}

export function getEstadoConductor() {
  if (
    localStorage.getItem("EstadoConductor") === null ||
    localStorage.getItem("EstadoConductor") === undefined
  ) {
    if (
      cookies.get("EstadoConductor") === null ||
      cookies.get("EstadoConductor") === undefined
    ) {
    } else {
      _EstadoConductor = cookies.get("EstadoConductor");
    }
  } else {
    _EstadoConductor = localStorage.getItem("EstadoConductor");
  }

  return _EstadoConductor;
}

////////////////////////////////////////////////////////////

let _EstadoConexionGPS = "";

export function setEstadoConexionGPS(value) {
  _EstadoConexionGPS = value;
  localStorage.setItem("EstadoConexionGPS", _EstadoConexionGPS);
  cookies.set("EstadoConexionGPS", _EstadoConexionGPS, { path: "/" });
}

export function getEstadoConexionGPS() {
  if (
    localStorage.getItem("EstadoConexionGPS") === null ||
    localStorage.getItem("EstadoConexionGPS") === undefined
  ) {
    if (
      cookies.get("EstadoConexionGPS") === null ||
      cookies.get("EstadoConexionGPS") === undefined
    ) {
    } else {
      _EstadoConexionGPS = cookies.get("EstadoConexionGPS");
    }
  } else {
    _EstadoConexionGPS = localStorage.getItem("EstadoConexionGPS");
  }

  return _EstadoConexionGPS;
}

////////////////////////////////////////////////////////////

let _UltimaUbicacionFechaHora = "";

export function setUltimaUbicacionFechaHora(value) {
  _UltimaUbicacionFechaHora = value;
  localStorage.setItem("UltimaUbicacionFechaHora", _UltimaUbicacionFechaHora);
  cookies.set("UltimaUbicacionFechaHora", _UltimaUbicacionFechaHora, {
    path: "/",
  });
}

export function getUltimaUbicacionFechaHora() {
  if (
    localStorage.getItem("UltimaUbicacionFechaHora") === null ||
    localStorage.getItem("UltimaUbicacionFechaHora") === undefined
  ) {
    if (
      cookies.get("UltimaUbicacionFechaHora") === null ||
      cookies.get("UltimaUbicacionFechaHora") === undefined
    ) {
    } else {
      _UltimaUbicacionFechaHora = cookies.get("UltimaUbicacionFechaHora");
    }
  } else {
    _UltimaUbicacionFechaHora = localStorage.getItem(
      "UltimaUbicacionFechaHora"
    );
  }

  return _UltimaUbicacionFechaHora;
}

////////////////////////////////////////////////////////////

let _usuarioPerfil = "";

export function setusuarioPerfil(value) {
  _usuarioPerfil = value;
  localStorage.setItem("usuarioPerfil", _usuarioPerfil);
  cookies.set("usuarioPerfil", _usuarioPerfil, { path: "/" });
}

export function getusuarioPerfil() {
  if (
    localStorage.getItem("usuarioPerfil") === null ||
    localStorage.getItem("usuarioPerfil") === undefined
  ) {
    if (
      cookies.get("usuarioPerfil") === null ||
      cookies.get("usuarioPerfil") === undefined
    ) {
    } else {
      _usuarioPerfil = cookies.get("usuarioPerfil");
    }
  } else {
    _usuarioPerfil = localStorage.getItem("usuarioPerfil");
  }

  return _usuarioPerfil;
}

////////////////////////////////////////////////////////////

let _VersionBackend = "";

export function setVersionBackend(value) {
  _VersionBackend = value;
  localStorage.setItem("VersionBackend", _VersionBackend);
  cookies.set("VersionBackend", _VersionBackend, { path: "/" });
}

export function getVersionBackend() {
  if (
    localStorage.getItem("VersionBackend") === null ||
    localStorage.getItem("VersionBackend") === undefined
  ) {
    if (
      cookies.get("VersionBackend") === null ||
      cookies.get("VersionBackend") === undefined
    ) {
    } else {
      _VersionBackend = cookies.get("VersionBackend");
    }
  } else {
    _VersionBackend = localStorage.getItem("VersionBackend");
  }

  return _VersionBackend;
}

////////////////////////////////////////////////////////////

let _LocalidadIP = "";

export function setLocalidadIP(value) {
  _LocalidadIP = value;
  localStorage.setItem("LocalidadIP", _LocalidadIP);
  cookies.set("LocalidadIP", _LocalidadIP, { path: "/" });
}

export function getLocalidadIP() {
  if (
    localStorage.getItem("LocalidadIP") === null ||
    localStorage.getItem("LocalidadIP") === undefined
  ) {
    if (
      cookies.get("LocalidadIP") === null ||
      cookies.get("LocalidadIP") === undefined
    ) {
    } else {
      _LocalidadIP = cookies.get("LocalidadIP");
    }
  } else {
    _LocalidadIP = localStorage.getItem("LocalidadIP");
  }

  return _LocalidadIP;
}

////////////////////////////////////////////////////////////

let _Provincia = "";

export function setProvincia(value) {
  _Provincia = value;
  localStorage.setItem("Provincia", _Provincia);
  cookies.set("Provincia", _Provincia, { path: "/" });
}

export function getProvincia() {
  if (
    localStorage.getItem("Provincia") === null ||
    localStorage.getItem("Provincia") === undefined
  ) {
    if (
      cookies.get("Provincia") === null ||
      cookies.get("Provincia") === undefined
    ) {
    } else {
      _Provincia = cookies.get("Provincia");
    }
  } else {
    _Provincia = localStorage.getItem("Provincia");
  }

  return _Provincia;
}

////////////////////////////////////////////////////////////

let _partidaLatitud = "";

export function setpartidaLatitud(value) {
  _partidaLatitud = value;
  localStorage.setItem("partidaLatitud", _partidaLatitud);
  cookies.set("partidaLatitud", _partidaLatitud, { path: "/" });
}

export function getpartidaLatitud() {
  if (
    localStorage.getItem("partidaLatitud") === null ||
    localStorage.getItem("partidaLatitud") === undefined
  ) {
    if (
      cookies.get("partidaLatitud") === null ||
      cookies.get("partidaLatitud") === undefined
    ) {
    } else {
      _partidaLatitud = cookies.get("partidaLatitud");
    }
  } else {
    _partidaLatitud = localStorage.getItem("partidaLatitud");
  }

  return _partidaLatitud;
}

////////////////////////////////////////////////////////////

let _partidaLongitud = "";

export function setpartidaLongitud(value) {
  _partidaLongitud = value;
  localStorage.setItem("partidaLongitud", _partidaLongitud);
  cookies.set("partidaLongitud", _partidaLongitud, { path: "/" });
}

export function getpartidaLongitud() {
  if (
    localStorage.getItem("partidaLongitud") === null ||
    localStorage.getItem("partidaLongitud") === undefined
  ) {
    if (
      cookies.get("partidaLongitud") === null ||
      cookies.get("partidaLongitud") === undefined
    ) {
    } else {
      _partidaLongitud = cookies.get("partidaLongitud");
    }
  } else {
    _partidaLongitud = localStorage.getItem("partidaLongitud");
  }

  return _partidaLongitud;
}

////////////////////////////////////////////////////////////

let _partidaUbicacion = "";

export function setpartidaUbicacion(value) {
  _partidaUbicacion = value;
  localStorage.setItem("partidaUbicacion", _partidaUbicacion);
  cookies.set("partidaUbicacion", _partidaUbicacion, { path: "/" });
}

export function getpartidaUbicacion() {
  if (
    localStorage.getItem("partidaUbicacion") === null ||
    localStorage.getItem("partidaUbicacion") === undefined
  ) {
    if (
      cookies.get("partidaUbicacion") === null ||
      cookies.get("partidaUbicacion") === undefined
    ) {
    } else {
      _partidaUbicacion = cookies.get("partidaUbicacion");
    }
  } else {
    _partidaUbicacion = localStorage.getItem("partidaUbicacion");
  }

  return _partidaUbicacion;
}

////////////////////////////////////////////////////////////

let _destinoLatitud = "";

export function setdestinoLatitud(value) {
  _destinoLatitud = value;
  localStorage.setItem("destinoLatitud", _destinoLatitud);
  cookies.set("destinoLatitud", _destinoLatitud, { path: "/" });
}

export function getdestinoLatitud() {
  if (
    localStorage.getItem("destinoLatitud") === null ||
    localStorage.getItem("destinoLatitud") === undefined
  ) {
    if (
      cookies.get("destinoLatitud") === null ||
      cookies.get("destinoLatitud") === undefined
    ) {
    } else {
      _destinoLatitud = cookies.get("destinoLatitud");
    }
  } else {
    _destinoLatitud = localStorage.getItem("destinoLatitud");
  }

  return _destinoLatitud;
}

////////////////////////////////////////////////////////////

let _destinoLongitud = "";

export function setdestinoLongitud(value) {
  _destinoLongitud = value;
  localStorage.setItem("destinoLongitud", _destinoLongitud);
  cookies.set("destinoLongitud", _destinoLongitud, { path: "/" });
}

export function getdestinoLongitud() {
  if (
    localStorage.getItem("destinoLongitud") === null ||
    localStorage.getItem("destinoLongitud") === undefined
  ) {
    if (
      cookies.get("destinoLongitud") === null ||
      cookies.get("destinoLongitud") === undefined
    ) {
    } else {
      _destinoLongitud = cookies.get("destinoLongitud");
    }
  } else {
    _destinoLongitud = localStorage.getItem("destinoLongitud");
  }

  return _destinoLongitud;
}

////////////////////////////////////////////////////////////

let _destinoUbicacion = "";

export function setdestinoUbicacion(value) {
  _destinoUbicacion = value;
  localStorage.setItem("destinoUbicacion", _destinoUbicacion);
  cookies.set("destinoUbicacion", _destinoUbicacion, { path: "/" });
}

export function getdestinoUbicacion() {
  if (
    localStorage.getItem("destinoUbicacion") === null ||
    localStorage.getItem("destinoUbicacion") === undefined
  ) {
    if (
      cookies.get("destinoUbicacion") === null ||
      cookies.get("destinoUbicacion") === undefined
    ) {
    } else {
      _destinoUbicacion = cookies.get("destinoUbicacion");
    }
  } else {
    _destinoUbicacion = localStorage.getItem("destinoUbicacion");
  }

  return _destinoUbicacion;
}

////////////////////////////////////////////////////////////

let _Identificacion = "";

export function setIdentificacion(value) {
  _Identificacion = value;

  localStorage.setItem("Identificacion", _Identificacion);
  cookies.set("Identificacion", _Identificacion, { path: "/" });
}

export function getIdentificacion() {
  if (
    localStorage.getItem("Identificacion") === null ||
    localStorage.getItem("Identificacion") === undefined
  ) {
    if (
      cookies.get("Identificacion") === null ||
      cookies.get("Identificacion") === undefined
    ) {
    } else {
      _Identificacion = cookies.get("Identificacion");
    }
  } else {
    _Identificacion = localStorage.getItem("Identificacion");
  }

  return _Identificacion;
}

////////////////////////////////////////////////////////////

let _TokenNotificacion = "";

export function setTokenNotificacion(value) {
  _TokenNotificacion = value;

  localStorage.setItem("TokenNotificacion", _TokenNotificacion);
  cookies.set("TokenNotificacion", _TokenNotificacion, { path: "/" });
}

export function getTokenNotificacion() {
  if (
    localStorage.getItem("TokenNotificacion") === null ||
    localStorage.getItem("TokenNotificacion") === undefined
  ) {
    if (
      cookies.get("TokenNotificacion") === null ||
      cookies.get("TokenNotificacion") === undefined
    ) {
    } else {
      _TokenNotificacion = cookies.get("TokenNotificacion");
    }
  } else {
    _TokenNotificacion = localStorage.getItem("TokenNotificacion");
  }

  return _TokenNotificacion;
}

////////////////////////////////////////////////////////////

let _PermitirNotificaciones = "";

export function setPermitirNotificaciones(value) {
  _PermitirNotificaciones = value;

  localStorage.setItem("PermitirNotificaciones", _PermitirNotificaciones);
  cookies.set("PermitirNotificaciones", _PermitirNotificaciones, { path: "/" });
}

export function getPermitirNotificaciones() {
  if (
    localStorage.getItem("PermitirNotificaciones") === null ||
    localStorage.getItem("PermitirNotificaciones") === undefined
  ) {
    if (
      cookies.get("PermitirNotificaciones") === null ||
      cookies.get("PermitirNotificaciones") === undefined
    ) {
    } else {
      _PermitirNotificaciones = cookies.get("PermitirNotificaciones");
    }
  } else {
    _PermitirNotificaciones = localStorage.getItem("PermitirNotificaciones");
  }

  return _PermitirNotificaciones;
}

////////////////////////////////////////////////////////////

let _PoolingActivado = false;

export function setPoolingActivado(value) {
  _PoolingActivado = value;

  localStorage.setItem("PoolingActivado", _PoolingActivado);
  cookies.set("PoolingActivado", _PoolingActivado, { path: "/" });
}

export function getPoolingActivado() {
  if (
    localStorage.getItem("PoolingActivado") === null ||
    localStorage.getItem("PoolingActivado") === undefined
  ) {
    if (
      cookies.get("PoolingActivado") === null ||
      cookies.get("PoolingActivado") === undefined
    ) {
    } else {
      _PoolingActivado = cookies.get("PoolingActivado");
    }
  } else {
    _PoolingActivado = localStorage.getItem("PoolingActivado");
  }

  return _PoolingActivado;
}

////////////////////////////////////////////////////////////

let _ViajeId = false;

export function setViajeId(value) {
  _ViajeId = value;

  localStorage.setItem("ViajeId", _ViajeId);
  cookies.set("ViajeId", _ViajeId, { path: "/" });
}

export function getViajeId() {
  if (
    localStorage.getItem("ViajeId") === null ||
    localStorage.getItem("ViajeId") === undefined
  ) {
    if (
      cookies.get("ViajeId") === null ||
      cookies.get("ViajeId") === undefined
    ) {
    } else {
      _ViajeId = cookies.get("ViajeId");
    }
  } else {
    _ViajeId = localStorage.getItem("ViajeId");
  }

  return _ViajeId;
}

////////////////////////////////////////////////////////////

let _Geolocalizacion = null;

export function setGeolocalizacion(value) {
  _Geolocalizacion = value;

  localStorage.setItem("Geolocalizacion", _Geolocalizacion);
  cookies.set("Geolocalizacion", _Geolocalizacion, { path: "/" });
}

export function getGeolocalizacion() {
  if (
    localStorage.getItem("Geolocalizacion") === null ||
    localStorage.getItem("Geolocalizacion") === undefined
  ) {
    if (
      cookies.get("Geolocalizacion") === null ||
      cookies.get("Geolocalizacion") === undefined
    ) {
    } else {
      _Geolocalizacion = cookies.get("Geolocalizacion");
    }
  } else {
    _Geolocalizacion = localStorage.getItem("Geolocalizacion");
  }

  return _Geolocalizacion;
}

////////////////////////////////////////////////////////////

let _GoogleMapsHabilitado = false;

export function setGoogleMapsHabilitado(value) {
  _GoogleMapsHabilitado = value;

  localStorage.setItem("GoogleMapsHabilitado", _GoogleMapsHabilitado);
  cookies.set("GoogleMapsHabilitado", _GoogleMapsHabilitado, { path: "/" });
}

export function getGoogleMapsHabilitado() {
  if (
    localStorage.getItem("GoogleMapsHabilitado") === null ||
    localStorage.getItem("GoogleMapsHabilitado") === undefined
  ) {
    if (
      cookies.get("GoogleMapsHabilitado") === null ||
      cookies.get("GoogleMapsHabilitado") === undefined
    ) {
    } else {
      _GoogleMapsHabilitado = cookies.get("GoogleMapsHabilitado");
    }
  } else {
    _GoogleMapsHabilitado = localStorage.getItem("GoogleMapsHabilitado");
  }

  return _GoogleMapsHabilitado;
}
